module.exports = __webpack_public_path__ + "img/avatar6.8d27bc67.png";